import {Component, OnInit} from '@angular/core';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {FtaService} from '../../../service/fta.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {ActivatedRoute} from '@angular/router';
import {FTA, ResumoFTA} from '../../../model/catalogo';
import {TipoPeriodicidade} from '../../../model/constantes';
import {UtilApi} from '../../../service/api/util.api';
import {ConstantesApiService} from '../../../service/api/constantes.api';

@Component({
    selector: 'resumo-fta-modal',
    templateUrl: './resumo-fta-modal.component.html',
    styleUrls: ['./resumo-fta-modal.component.css']
})
export class ResumoFtaModalComponent {

    constructor(private globalService: GlobalService, private ftaService: FtaService, public modalService: ModalService, private utilApi: UtilApi,
                private constantesService: ConstantesApiService, private pesquisaService: PesquisasFiltroApiService) {
    }

    fta: FTA = new FTA();
    resumoFta: ResumoFTA = new ResumoFTA();
    periodicidades: Array<TipoPeriodicidade> = new Array<TipoPeriodicidade>();
    plataformas: any = {
        'highend': 'Servidor High-End', 'mainframe': 'Mainframe', 'web': 'Web',
        'xfb': 'PESIT/XFB', 'rvs': 'Odette/RVS', 'connect': 'Connect:Direct'
    };

    ngOnInit() {
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, ResumoFtaModalComponent.prototype.carregarConstantes);
        this.fta = this.ftaService.fta;
        this.resumoFta = this.ftaService.resumoFTA;
    }

    carregarConstantes() {
        this.constantesService.buscaTipoPeriodicidade(0)
            .subscribe(periodicidades => this.periodicidades = periodicidades as Array<TipoPeriodicidade>);
    }

    getPeriodicidade(codigo: Number) {
        let periodicidade = this.periodicidades.find(x => x.codigo == codigo);
        if (periodicidade != null) {
            return periodicidade.nome;
        }
        return '-';
    }

    getPlataforma(plat: string) {
        if (this.plataformas[plat] != '') {
            return this.plataformas[plat];
        } else {
            return '-';
        }
    }

    confirmar() {
        this.modalService.incluirDadosGerados('confirmar');
        this.modalService.fecharPaginaModal();
    }

    cancelar() {
        this.modalService.fecharPaginaModal();
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/resumo-novo-fta-modal/resumo-fta-modal.component.ts